
import React, { useEffect, useState, useRef } from "react";
import { Table, Button, Input, Space, Tag, Modal, Typography, message, Descriptions, Badge, Divider, App, Card, Select, Row, Col, Statistic } from "antd";
import { SearchOutlined, ReloadOutlined, EyeOutlined, DownloadOutlined, CloseOutlined, UserOutlined, CheckCircleOutlined, CloseCircleOutlined, TeamOutlined } from "@ant-design/icons";
import AdminLayout from "./Drawer";
import { formatDate, formatDateTime } from "../comman";
import "./userList.css";
import * as XLSX from 'xlsx';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const { Text } = Typography;
const { Option } = Select;
const NewUserList = () => {
  const [events, setEvents] = useState([]);
  const [list, setList] = useState([]);
  // console.log('Events List:', list);
  const [loading, setLoading] = useState(false);
  const [openDocModal, setOpenDocModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  //console.log('Users Data:', usersData);
  const [openRequestModal, setOpenRequestModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  // console.log(selectedRequest);
  const gatePassRef = useRef(null);
  const userData = JSON.parse(localStorage.getItem('user'));
  //console.log('User Data:', userData.data.user.name);
  // PDF dimensions (similar to your iCard implementation)
  const widthInches = 8.27; // A4 width
  const heightInches = 11.69; // A4 height
  const [stats, setStats] = useState({
    total: 0,
    approved: 0,
    rejected: 0,
    pending: 0
  });

  //console.log('User Stats:', stats);
  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    fetchAllUsers();
    fetchUserStats();
  }, []);

  useEffect(() => {
    setFilteredData(usersData);
  }, [usersData]);

  const fetchEvents = async () => {
    try {
      const response = await fetch("/api/new/get/events", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.status === "success") {
        setList(data.data);
      } else {
        console.error("Error in response data:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error.message);
      message.error("Failed to fetch events");
    }
  };

  const fetchAllUsers = async () => {
    setLoading(true);
    try {
      const response = await fetch("/api/new/get/users", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.status === "success") {
        setUsersData(data.data);
      } else {
        console.error("Error in response data:", data);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      message.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };


  const fetchUserStats = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/getcount'); // Make sure this matches your backend route
      const result = await response.json();

      //console.log('Full API Response:', result); // Debug log

      if (result.status === "success") {
        setStats(result.data); // This should contain {total, approved, rejected, pending}
      } else {
        throw new Error(result.message || 'Failed to fetch stats');
      }
    } catch (err) {
      console.error('Error fetching user stats:', err);
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (record) => {
    // console.log(record);
    try {
      const response = await fetch(`/api/new/approve-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: record.key,
          mobileNumber: record.mobileNumber,
          approveBy: userData.data.user.name
        }),
      });

      const result = await response.json();
      //console.log(result);

      if (response.ok) {
        setUsersData((prev) =>
          prev.map((item) =>
            item.mobileNumber === record.mobileNumber
              ? { ...item, approve_status: "approved", qrCodeLink: result.data?.qrCodeLink }
              : item
          )
        );
        message.success("User approved successfully!");
        setOpenRequestModal(false);

        // Generate gate pass after approval - Use the updated record with QR code
        await generateGatePass({
          ...record,
          approve_status: "approved",
          qrCodeLink: result.data?.qrCodeLink
        });
      } else {
        message.error(result.message || "Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      message.error("Error approving user. Please try again.");
    }
  };

  const handleReject = async (record) => {
    try {
      const response = await fetch(`/api/new/reject-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobileNumber: record.mobileNumber,
          rejectedBy: userData.data.user.name
        }),
      });

      const data = await response.json();
      if (response.ok) {
        setUsersData((prev) =>
          prev.map((item) =>
            item.mobileNumber === record.mobileNumber
              ? { ...item, approve_status: "rejected" }
              : item
          )
        );
        message.success("User rejected successfully!");
        setOpenRequestModal(false);
      } else {
        message.error(data.message || "Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      message.error("Error rejecting user. Please try again.");
    }
  };

  // Format name function (similar to your iCard implementation)
  const formatName = (name) => {
    if (!name) return '';
    return name.toUpperCase();
  };



  const generateGatePass = async (record, staffName = null) => {
    try {
      //console.log('Generating gate pass for:', record);

      // Determine pass type based on designation
      let passType = record.designation || 'Media';
      if (record.designation === "Press") {
        passType = record.pressType === "Print Media" ? "Print Media" : "Electronic Media";
      }

      // Prepare data for gate pass
      const gatePassData = {
        name: staffName || record.name,
        mediaHouse: record.mediaHouseName || 'N/A',
        designation: passType,
        passType: record.designation,
        // mobileNumber: record.mobileNumber,
        eventName: 'KHASDAR UTSAV 2024',
        eventDate: 'Octomber 07-18, 2025',
        eventVenue: 'Civil Lines, Nagpur',
        photographerName: record.photographerName,
        cameramanName: record.cameramanName,
        validUntil: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString(),
        passId: `GP-${Date.now()}-${Math.random().toString(36).substr(2, 5).toUpperCase()}`,
        qrCodeLink: record.qrCodeLink || ''
      };




      const fileName = `${formatName(record.name)}_${Date.now()}.pdf`;
      await generatePDFGatePass(gatePassData, fileName);
      message.success("Gate pass generated successfully!");


    } catch (error) {
      console.error('Error generating gate passes:', error);
      message.error("Failed to generate gate passes. Please try again.");
    }
  };

  const generatePDFGatePass = async (data, fileName) => {
    try {
      // ID Card dimensions in inches (vertical orientation)
      const widthInches = 2.50;
      const heightInches = 3.70;

      // Convert to pixels for HTML (96 DPI)
      const widthPixels = widthInches * 96;
      const heightPixels = heightInches * 96;

      // Create PDF with ID card size
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'in',
        format: [widthInches, heightInches]
      });

      // Function to adjust font size dynamically
      const adjustFontSize = (element, container, baseSize, minSize, increaseThreshold = 15) => {
        if (!element || !container) return;

        const textContent = element.textContent.trim();
        const charCount = textContent.length;
        const maxHeight = container.clientHeight;

        // Start with larger size if text is short
        let fontSize = charCount < increaseThreshold ? baseSize + 2 : baseSize;
        element.style.fontSize = fontSize + 'px';

        // Force reflow
        void element.offsetHeight;

        // Reduce font size if content overflows
        let attempts = 0;
        while (element.scrollHeight > maxHeight && fontSize > minSize && attempts < 20) {
          fontSize -= 1;
          element.style.fontSize = fontSize + 'px';
          void element.offsetHeight; // Force reflow each iteration
          attempts++;
        }
      };

      // Function to generate a single page
      const generatePage = async (isFrontSide) => {
        // Create a temporary container for the gate pass
        const container = document.createElement('div');
        container.style.cssText = `
        position: absolute;
        top: -10000px;
        left: -10000px;
        width: ${widthPixels}px;
        height: ${heightPixels}px;
        overflow: hidden;
        background: white;
        font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Arial', sans-serif;
      `;

        if (isFrontSide) {
          // FRONT SIDE HTML with FIXED CONTAINERS
          container.innerHTML = `
          <div style="
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
          ">
            <!-- Front Background Image -->
            <img src="/frontside.svg" alt="Gate Pass Background" style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              z-index: 0;
            " crossorigin="anonymous" onerror="this.src='https://placehold.co/240x355/ffcdd2/7A1A4E?text=FRONT+SIDE+BG'" />

            <!-- Content Overlay (Dynamic Data) with FIXED POSITIONS -->
            <div style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
              display: flex;
              flex-direction: column;
              box-sizing: border-box;
            ">
              
              <!-- Top Spacer - FIXED HEIGHT -->
              <div style="
                height: 75px;
                flex-shrink: 0;
              "></div>

              <!-- NAME SECTION - FIXED CONTAINER -->
              <div id="nameContainer" style="
                width: 100%;
                height: 42px;
                padding: 0 8px;
                box-sizing: border-box;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                overflow: hidden;
              ">
                <div id="nameText" style="
                  font-weight: 700;
                  font-size: 18px;
                  color: #a31740;
                  line-height: 1.2;
                  max-width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  word-break: break-word;
                ">
                  ${data.name}
                </div>
              </div>

              <!-- MEDIA HOUSE NAME - FIXED CONTAINER -->
              <div id="mediaHouseContainer" style="
                width: 100%;
                height: 32px;
                padding: 0 8px;
                box-sizing: border-box;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                overflow: hidden;
              ">
                <div id="mediaHouseText" style="
                  font-weight: 500;
                  font-size: 12px;
                  color: #a31740;
                  line-height: 1.3;
                  max-width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  word-break: break-word;
                ">
                  ${data.mediaHouse}
                </div>
              </div>

              <!-- QR Code Container - FIXED SIZE -->
              <div style="
                width: 140px;
                height: 130px;
                margin: 0 auto;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                background: white;
              ">
                <img 
                  src="${data.qrCodeLink}" 
                  alt="QR Code"
                  style="
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  "
                  onload="console.log('QR Code loaded successfully')"
                  onerror="console.error('QR Code failed to load:', this.src.substring(0, 100) + '...')"
                />
              </div>

              <!-- Spacer between QR and Pass Type - FIXED HEIGHT -->
              <div style="
                height: 29px;
                flex-shrink: 0;
              "></div>
              
              <!-- PASS TYPE - FIXED CONTAINER (takes remaining space) -->
              <div style="
                width: 100%;
                flex: 1;
                min-height: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 2px 4px;
                box-sizing: border-box;
                overflow: hidden;
              ">
                <div id="passTypeText" style="
                  font-weight: 700;
                  font-size: 21px;
                  color: #ffffff;
                  line-height: 1.2;
                  text-transform: uppercase;
                  text-align: center;
                  letter-spacing: 1px;
                  max-width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  word-break: break-word;
                ">
                  ${data.passType.toUpperCase()}
                </div>
              </div>
            </div>
          </div>
        `;
        } else {
          // BACK SIDE HTML
          container.innerHTML = `
          <div style="
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
          ">
            <!-- Back Background Image -->
            <img src="/backside.svg" alt="Gate Pass Back Side" style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              z-index: 0;
            " crossorigin="anonymous" onerror="this.src='https://placehold.co/240x355/ffffff/000000?text=BACK+SIDE+BG'" />
          </div>
        `;
        }

        document.body.appendChild(container);

        // Wait for background image to load
        const bgImage = container.querySelector('img');
        if (bgImage && !bgImage.complete) {
          await new Promise((resolve) => {
            bgImage.onload = resolve;
            bgImage.onerror = resolve;
            setTimeout(resolve, 2000);
          });
        }

        if (isFrontSide) {
          // Wait for fonts to load
          if (document.fonts && document.fonts.ready) {
            await document.fonts.ready;
          }

          // Additional wait for rendering
          await new Promise(resolve => setTimeout(resolve, 100));

          // Apply dynamic font sizing AFTER container is attached and rendered
          const nameText = container.querySelector('#nameText');
          const nameContainer = container.querySelector('#nameContainer');
          adjustFontSize(nameText, nameContainer, 20, 12, 15);

          const mediaHouseText = container.querySelector('#mediaHouseText');
          const mediaHouseContainer = container.querySelector('#mediaHouseContainer');
          adjustFontSize(mediaHouseText, mediaHouseContainer, 14, 9, 15);

          // Wait a bit more for font adjustments to render
          await new Promise(resolve => setTimeout(resolve, 200));
        } else {
          // For back side, just wait for rendering
          await new Promise(resolve => setTimeout(resolve, 300));
        }

        // Generate canvas with high quality
        const canvas = await html2canvas(container, {
          scale: 4,
          useCORS: true,
          allowTaint: true,
          width: widthPixels,
          height: heightPixels,
          backgroundColor: '#ffffff',
          logging: false,
          imageTimeout: 0
        });

        document.body.removeChild(container);

        return canvas.toDataURL('image/jpeg', 0.95);
      };

      // Generate front side
      const frontSideImage = await generatePage(true);

      // Add front side to PDF
      pdf.addImage(frontSideImage, 'JPEG', 0, 0, widthInches, heightInches);

      // Add back side as new page
      pdf.addPage();
      const backSideImage = await generatePage(false);
      pdf.addImage(backSideImage, 'JPEG', 0, 0, widthInches, heightInches);

      // Save the PDF with both pages
      pdf.save(fileName);

    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  };



  const handleManualDownload = async (record) => {
    try {
      await generateGatePass(record);
    } catch (error) {
      console.error('Error in manual download:', error);
      message.error('Failed to download gate pass');
    }
  };

  // Rest of your existing functions...
  const handleStatus = (value) => {
    const event = list && list?.filter((item) => item._id === value)[0];
    return event?.eventName;
  };

  const handleSearch = (value) => {
    setSearchText(value);
    if (!value) {
      setFilteredData(usersData);
      return;
    }

    const searchValue = value.toLowerCase();
    const filtered = usersData.filter((item) => {
      return (
        item?.firstName?.toLowerCase().includes(searchValue) ||
        item?.mobileNumber?.toString().includes(searchValue) ||
        item?.approve_status?.toLowerCase().includes(searchValue) ||
        item?.pincode?.toString().includes(searchValue) ||
        item?.address?.toLowerCase().includes(searchValue)
      );
    });
    setFilteredData(filtered);
  };

  const handleReset = () => {
    setSearchText("");
    setFilteredData(usersData);
  };

  const handleExport = () => {
    const exportData = rows.map(row => ({
      "Sr.No.": row.id,
      "User Name": row.name,
      "Mobile Number": row.mobileNumber,

      "Media Type": row.designation,
      "Media House": row.mediaHouseName,
      "Status": row.status,
      "Created At": row.creation,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    XLSX.writeFile(workbook, `Users_${new Date().toISOString().split('T')[0]}.xlsx`);
    message.success("Data exported successfully!");
  };

  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "id",
      key: "id",
      width: 80,
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Media Personnel Name",
      dataIndex: "name",
      key: "name",
      width: 150,
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
      width: 150,
    },
    {
      title: "Document",
      dataIndex: "documentPath",
      key: "documentPath",
      width: 120,
      render: (documentPath) => {
        return documentPath ? (
          <Button
            type="link"
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              const normalizedPath = documentPath.replace(/\\/g, '/');
              setSelectedDocument(normalizedPath);
              setOpenDocModal(true);
            }}
          >
            View
          </Button>
        ) : (
          <Text type="secondary">No Document</Text>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      filters: [
        { text: "Approved", value: "approved" },
        { text: "Pending", value: "pending" },
        { text: "Rejected", value: "rejected" },
      ],
      onFilter: (value, record) => record.status === value,
      render: (status) => {
        let color = "default";
        let text = status;

        switch (status) {
          case "approved":
            color = "success";
            text = "Approved";
            break;
          case "pending":
            color = "warning";
            text = "Pending";
            break;
          case "rejected":
            color = "error";
            text = "Rejected";
            break;
          default:
            color = "default";
            text = status || "Unknown";
        }

        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      align: "center",
      render: (_, record) => {
        const isApproved = record.status === "approved";
        const isRejected = record.status === "rejected";
        const isPending = record.status === "pending";

        return (
          <Button
            type={isPending ? "primary" : "default"}
            size="small"
            onClick={() => {
              setSelectedRequest(record);
              setOpenRequestModal(true);
            }}
          >
            {isApproved ? "View Details" : isRejected ? "View Details" : "Respond"}
          </Button>
        );
      },
    }
  ];

  const rows = filteredData.map((item, index) => ({
    key: item._id || index,
    id: index + 1,
    name: item?.firstName,
    mobileNumber: item?.mobileNumber,
    pincode: item?.pincode,
    address: item?.address,
    limit: item?.eventLimit,
    event: handleStatus(item?.eventId),
    creation: item?.createdAt && formatDateTime(item.createdAt),
    eventId: item?.eventId,
    gate: item?.gate,
    coordinates: item?.coordinates?.lat && JSON.stringify(item.coordinates),
    qrCodeLink: item?.qrCodeLink,
    status: item?.approve_status,
    documentPath: item?.documentPath,
    mediaHouseName: item?.mediaHouseName,
    designation: item?.designation,
    photographerName: item?.photographerName,
    cameramanName: item?.cameramanName,
    followersCount: item?.followersCount,
    socialMediaLinks: item?.socialMediaLinks,
    pressType: item?.pressType,
    platformNames: item?.platformNames
  }));

  return (
    <AdminLayout>
      <p style={{ fontSize: "1.5em", fontWeight: "bold", marginBottom: "20px" }}>
        Manage Media Requests
      </p>
      <div style={{ padding: "24px", background: "#f0f2f5" }}>
        <div style={{ marginBottom: 24 }}>
          <Card>


            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <Card bordered={false} style={{ background: '#e6f7ff' }}>
                  <Statistic
                    title="Total Requests"
                    value={stats.total || 0}
                    // title={selectedEvent === "all" ? "Total Users" : "Event Registrations"}
                    // value={statistics.eventSpecificStats ? statistics.eventSpecificStats.registeredForEvent : statistics.totalRegistrations}
                    prefix={<UserOutlined />}
                    valueStyle={{ color: '#1890ff', fontSize: '20px' }}
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <Card bordered={false} style={{ background: '#f6ffed' }}>
                  <Statistic
                    title="Approved Requests"
                    value={stats.approved || 0}
                    // value={statistics.eventSpecificStats ? statistics.eventSpecificStats.activeInEvent : statistics.activeUsers}
                    prefix={<CheckCircleOutlined />}
                    // suffix={`(${statistics.eventSpecificStats ? statistics.eventSpecificStats.eventActivationRate : statistics.activationRate}%)`}
                    valueStyle={{ color: '#52c41a', fontSize: '20px' }}
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <Card bordered={false} style={{ background: '#f9f0ff' }}>
                  <Statistic
                    title=" Pending Requests"
                    value={stats.pending || 0}
                    // title={selectedEvent === "all" ? "Total Attended" : "Users Attended"}
                    // value={statistics.eventSpecificStats ? statistics.eventSpecificStats.attendedEvent : statistics.usersWithAttendance}
                    prefix={<TeamOutlined />}
                    // suffix={`(${statistics.eventSpecificStats ? statistics.eventSpecificStats.eventAttendanceRate : statistics.attendanceRate}%)`}
                    valueStyle={{ color: '#722ed1', fontSize: '20px' }}
                  />
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <Card bordered={false} style={{ background: '#fff1f0' }}>
                  <Statistic
                    title=" Rejected Requests"

                    value={stats.rejected || 0}
                    // value={statistics.eventSpecificStats ? statistics.eventSpecificStats.inactiveInEvent : statistics.inactiveUsers}
                    prefix={<CloseCircleOutlined />}
                    valueStyle={{ color: '#ff4d4f', fontSize: '20px' }}
                  />
                </Card>
              </Col>

            </Row>
          </Card>
        </div>
        <div style={{ background: "#fff", padding: "24px", borderRadius: "8px" }}>
          <Space style={{ marginBottom: 16, width: "100%", justifyContent: "space-between", flexWrap: "wrap" }}>
            <Space wrap>
              <Input
                placeholder="Search by name, mobile, pincode, or address"
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 350 }}
                allowClear
              />
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Reset
              </Button>
            </Space>
            <Space>
              <Text type="secondary">
                Showing {rows.length} of {usersData.length} records
              </Text>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleExport}
              >
                Export
              </Button>
            </Space>
          </Space>

          <Table
            columns={columns}
            dataSource={rows}
            loading={loading}
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              pageSizeOptions: ["10", "20", "50", "100"],
            }}
            bordered
            size="middle"
            scroll={{ x: 1000 }}
          />
        </div>
      </div>

      {/* Document Viewer Modal */}
      <Modal
        open={openDocModal}
        onClose={() => setOpenDocModal(false)}
        footer={null}
        width="50%"
        style={{ top: 90 }}
        closeIcon={<CloseOutlined />}
        onCancel={() => setOpenDocModal(false)}
      >
        <div style={{ height: "50vh" }}>
          {selectedDocument ? (
            selectedDocument.endsWith(".pdf") ? (
              <iframe
                src={`${selectedDocument.startsWith('http') ? selectedDocument : `${process.env.REACT_APP_DOCUMENT_PATH}/${selectedDocument}`}#toolbar=0`}
                width="100%"
                height="100%"
                style={{ border: "none" }}
                title="Document Viewer"
              />
            ) : (
              <img
                src={selectedDocument.startsWith('http') ? selectedDocument : `${process.env.REACT_APP_DOCUMENT_PATH}/${selectedDocument}`}
                alt="Uploaded Document"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            )
          ) : (
            <Text>No document found</Text>
          )}
        </div>
      </Modal>

      {/* Request Details Modal */}
      <Modal
        open={openRequestModal}
        onCancel={() => setOpenRequestModal(false)}
        footer={null}
        width={'90%'}
        style={{ maxWidth: 700 }}
        closeIcon={<CloseOutlined />}
        title={
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingRight: 40
          }}>
            <span style={{ fontSize: '22px', fontWeight: 600 }}> Review Request</span>
          </div>
        }
      >
        <Divider />
        {selectedRequest && (
          <div>
            <Divider orientation="left" style={{ marginTop: 2 }}> Request Details </Divider>
            <Descriptions column={1} bordered size="small">
              <Descriptions.Item label="Requested On">
                {selectedRequest.creation || new Date().toLocaleString()}
              </Descriptions.Item>
              <Descriptions.Item label="Full Name">
                {selectedRequest.name}
              </Descriptions.Item>
              <Descriptions.Item label="Media Type">
                {selectedRequest.designation}
              </Descriptions.Item>
              <Descriptions.Item label="Media House Name">
                {selectedRequest.mediaHouseName}
              </Descriptions.Item>
              <Descriptions.Item label="Phone">
                {selectedRequest.mobileNumber}
              </Descriptions.Item>
              {selectedRequest.pressType && (
                <Descriptions.Item label="Press Type">
                  {selectedRequest.pressType}
                </Descriptions.Item>
              )}
              {selectedRequest.photographerName && (
                <Descriptions.Item label="Photographer Name">
                  {selectedRequest.photographerName}
                </Descriptions.Item>
              )}
              {selectedRequest.cameramanName && (
                <Descriptions.Item label="Cameraman Name">
                  {selectedRequest.cameramanName}
                </Descriptions.Item>
              )}
              {selectedRequest.platformNames && selectedRequest.platformNames.length > 0 && (
                <>
                  {selectedRequest.platformNames.map((platform, index) => (
                    <Descriptions.Item
                      key={index}
                      label={platform || `Platform ${index + 1}`}
                    >
                      <div>
                        <div>
                          <strong>Followers:</strong>{' '}
                          {selectedRequest.followersCount && selectedRequest.followersCount[index]
                            ? selectedRequest.followersCount[index].toLocaleString()
                            : 'N/A'
                          }
                        </div>
                        <div>
                          <strong>Link:</strong>{' '}
                          {selectedRequest.socialMediaLinks && selectedRequest.socialMediaLinks[index] ? (
                            <a
                              href={selectedRequest.socialMediaLinks[index]}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1890ff', textDecoration: 'underline' }}
                            >
                              {selectedRequest.socialMediaLinks[index]}
                            </a>
                          ) : (
                            'N/A'
                          )}
                        </div>
                      </div>
                    </Descriptions.Item>
                  ))}
                </>
              )}
            </Descriptions>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 24,
              paddingTop: 16,
              borderTop: '1px solid #f0f0f0',
              flexWrap: 'wrap-reverse',
              gap: '8px'
            }}>
              <Button
                size="large"
                onClick={() => setOpenRequestModal(false)}
              >
                Close
              </Button>
              <Space style={{ flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                {selectedRequest.status === "approved" && (
                  <Button
                    type="default"
                    icon={<DownloadOutlined />}
                    size="large"
                    onClick={() => handleManualDownload(selectedRequest)}
                  >
                    Re-download Gatepass
                  </Button>
                )}
                <Button
                  size="large"
                  onClick={() => handleReject(selectedRequest)}
                  disabled={selectedRequest.status === "approved" || selectedRequest.status === "rejected"}
                >
                  Reject
                </Button>
                <Button
                  type="primary"
                  size="large"
                  onClick={() => handleApprove(selectedRequest)}
                  disabled={selectedRequest.status === "approved" || selectedRequest.status === "rejected"}
                >
                  {selectedRequest.status === "approved" ? "Already Approved" :
                    selectedRequest.status === "rejected" ? "Already Rejected" : "Approve"}
                </Button>
              </Space>
            </div>
          </div>
        )}
      </Modal>
    </AdminLayout>
  );
};

export default NewUserList;